import { render, staticRenderFns } from "./ViewReceivedBy.vue?vue&type=template&id=93ca1046&scoped=true"
import script from "./ViewReceivedBy.vue?vue&type=script&lang=js"
export * from "./ViewReceivedBy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93ca1046",
  null
  
)

export default component.exports